import React, { Component } from 'react';
import { SaveButton } from '../modalButtons';

function formatPhone(number) {
    if (!number) return '';
    var digits = number.replace(/\D/g, '');
    if (digits.length === 11 && digits[0] === '1') {
        return '+1 (' + digits.slice(1, 4) + ') ' + digits.slice(4, 7) + '-' + digits.slice(7);
    }
    if (digits.length === 10) {
        return '+1 (' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    }
    return number;
}

class PhoneNumbers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: false,
            tempData: false,
            sortBy: 'number',
            sortOrder: 1,
            filterBy: {},
            loading: false,
            error: ''
        };
    }

    cancel = () => {
        this.setState({ editData: false, tempData: false, loading: false, error: '' });
    }

    componentWillReceiveProps() {
        if (this.state.loading) {
            this.cancel();
        }
    }

    sort = (sortBy) => () => {
        var sortOrder = this.state.sortOrder === -1 ? 1 : -1;
        this.setState({ sortBy: sortBy, sortOrder: sortOrder });
    }

    filter = (field) => (e) => {
        var filterBy = Object.assign({}, this.state.filterBy);
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value;
        } else {
            delete filterBy[field];
        }
        this.setState({ filterBy: filterBy });
    }

    filterIcon(field) {
        return this.state.sortBy === field ? (this.state.sortOrder == 1 ? ' \u25B2' : ' \u25BC') : '';
    }

    sortFunc(sortBy, sortOrder) {
        return function(a, b) {
            var av = (a[sortBy] || '').toString().toLowerCase();
            var bv = (b[sortBy] || '').toString().toLowerCase();
            if (av === bv) return 0;
            return av > bv ? 1 * sortOrder : -1 * sortOrder;
        };
    }

    filterFunc(array, filterBy) {
        return array.filter(function(obj) {
            for (var prop in filterBy) {
                var val = (obj[prop] || '').toString().toLowerCase();
                if (val.indexOf(filterBy[prop].toString().toLowerCase()) < 0) return false;
            }
            return true;
        });
    }

    openEdit = (id) => () => {
        var data = (this.props.data.PhoneNumbers || {}).data || {};
        var item = data[id];
        if (!item) return;
        var tempData = Object.assign({}, item);
        if (!tempData.handlerType) tempData.handlerType = item.chatbot ? 'chatbot' : 'none';
        this.setState({ editData: true, tempData: tempData, error: '' });
    }

    editField = (field) => (e) => {
        this.setState(function(s) {
            return { tempData: Object.assign({}, s.tempData, { [field]: e.target.value }) };
        });
    }


    confirmEdit = () => {
        var item = this.state.tempData;
        this.props.ws.send(JSON.stringify({ route: 'addEditItem', module: 'PhoneNumbers', item: item }));
        this.setState({ loading: true, error: '' });
    }

    setHandlerType = (type) => {
        this.setState(function(s) {
            return { tempData: Object.assign({}, s.tempData, { handlerType: type }) };
        });
    }

    render() {
        if (!this.props.active) {
            return <div width="100%"></div>;
        }

        var rawData = (this.props.data.PhoneNumbers || {}).data || {};
        var chatbots = ((this.props.data.AIChatbots || {}).chatbots) || {};
        var ivrFlows = ((this.props.data.IVRFlows || {}).data) || {};
        var queues = ((this.props.data.Queues || {}).data) || {};

        var dataArray = Object.keys(rawData).map(function(id) {
            var item = rawData[id];
            var handlerType = item.handlerType || (item.chatbot ? 'chatbot' : 'none');
            var handlerName = '';
            if (handlerType === 'chatbot' && item.chatbot) {
                handlerName = chatbots[item.chatbot] ? (chatbots[item.chatbot].name || item.chatbot) : item.chatbot;
            } else if (handlerType === 'ivrFlow' && item.ivrFlowId) {
                handlerName = ivrFlows[item.ivrFlowId] ? (ivrFlows[item.ivrFlowId].name || item.ivrFlowId) : item.ivrFlowId;
            } else if (handlerType === 'queue' && item.queueId) {
                handlerName = queues[item.queueId] ? (queues[item.queueId].name || item.queueId) : item.queueId;
            }
            return Object.assign({}, item, { _id: id, handlerName: handlerName, handlerType: handlerType });
        });

        if (Object.keys(this.state.filterBy).length > 0) {
            dataArray = this.filterFunc(dataArray, this.state.filterBy);
        }
        dataArray.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder));

        var showSidebar = dataArray.length >= 10;
        var leftPanelStyle = showSidebar
            ? { width: '200px', marginRight: '50px', marginTop: '2px' }
            : { width: '0px', marginRight: '0px', marginTop: '2px' };

        var dataList = dataArray.map(function(item) {
            return (
                <tr className="dataRow" onClick={this.openEdit(item._id)} key={item._id} style={{ cursor: 'pointer', justifyContent: 'flex-start' }}>
                    <td style={{ width: '220px', flexShrink: 0, textAlign: 'left' }}>{formatPhone(item.number)}</td>
                    <td style={{ flex: 1.5, textAlign: 'left' }}>{item.description || '—'}</td>
                    <td style={{ width: '100px', flexShrink: 0, textAlign: 'left' }}>
                        {item.handlerType === 'chatbot' && <span style={badgeStyles.ai}>AI</span>}
                        {item.handlerType === 'ivrFlow' && <span style={badgeStyles.ivr}>IVR</span>}
                        {item.handlerType === 'queue' && <span style={badgeStyles.queue}>Queue</span>}
                    </td>
                    <td style={{ flex: 1, textAlign: 'left' }}>
                        {item.handlerName || '—'}
                    </td>
                    <td style={{ width: '120px', flexShrink: 0, textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {item.callRecording ? (
                            <div style={{ backgroundColor: '#002f5f', color: 'white', borderRadius: '50%', height: '20px', width: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <svg width="10" height="8" viewBox="0 0 10 8"><path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path></svg>
                            </div>
                        ) : null}
                    </td>
                </tr>
            );
        }.bind(this));

        var editModal = this.state.editData ? (
            <div className="blackout" tabIndex="1" autoFocus>
                <div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '480px', maxWidth: '92vw', padding: '0', position: 'relative', overflow: 'hidden' }}>
                    <div className="viewCloser" onClick={this.cancel}></div>

                    {/* Header */}
                    <div style={{ background: '#002f5f', padding: '28px 32px 22px', color: '#fff' }}>
                        <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', marginBottom: '6px' }}>Phone Number</div>
                        <div style={{ fontSize: '26px', fontWeight: '700', letterSpacing: '1px' }}>{formatPhone(this.state.tempData.number)}</div>
                    </div>

                    {/* Body */}
                    <div style={{ padding: '28px 32px 32px' }}>
                        <label style={labelStyle}>Description</label>
                        <input
                            type="text"
                            value={this.state.tempData.description || ''}
                            onChange={this.editField('description')}
                            placeholder="e.g. Main Support Line"
                            style={{ width: '100%', padding: '10px 12px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '15px', color: '#222', background: '#fff', marginBottom: '24px', boxSizing: 'border-box' }}
                        />

                        <label style={labelStyle}>Route</label>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                            {[{ id: 'none', label: 'None' }, { id: 'chatbot', label: 'Virtual Agent' }, { id: 'ivrFlow', label: 'IVR Flow' }, { id: 'queue', label: 'Queue' }].map(function(opt) {
                                var active = (this.state.tempData.handlerType || 'none') === opt.id;
                                return (
                                    <div key={opt.id} onClick={() => this.setHandlerType(opt.id)} style={{ flex: 1, textAlign: 'center', padding: '8px 0', borderRadius: '6px', border: '2px solid ' + (active ? '#002f5f' : '#dde3ea'), background: active ? '#002f5f' : '#fff', color: active ? '#fff' : '#555', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                                        {opt.label}
                                    </div>
                                );
                            }.bind(this))}
                        </div>

                        {(this.state.tempData.handlerType || 'none') === 'chatbot' && (
                            <select
                                value={this.state.tempData.chatbot || ''}
                                onChange={this.editField('chatbot')}
                                style={{ width: '100%', padding: '10px 12px', border: '1px solid #002f5f', borderRadius: '6px', fontSize: '15px', color: '#222', background: '#fff', marginBottom: '24px' }}
                            >
                                <option value="">— Select a Virtual Agent —</option>
                                {Object.keys(chatbots).map(function(k) {
                                    return <option key={k} value={k}>{chatbots[k].name || k}</option>;
                                })}
                            </select>
                        )}

                        {(this.state.tempData.handlerType || 'none') === 'ivrFlow' && (
                            <select
                                value={this.state.tempData.ivrFlowId || ''}
                                onChange={this.editField('ivrFlowId')}
                                style={{ width: '100%', padding: '10px 12px', border: '1px solid #1a5276', borderRadius: '6px', fontSize: '15px', color: '#222', background: '#fff', marginBottom: '24px' }}
                            >
                                <option value="">— Select an IVR Flow —</option>
                                {Object.keys(ivrFlows).map(function(k) {
                                    return <option key={k} value={k}>{ivrFlows[k].name || k}</option>;
                                })}
                            </select>
                        )}

                        {(this.state.tempData.handlerType || 'none') === 'queue' && (
                            <select
                                value={this.state.tempData.queueId || ''}
                                onChange={this.editField('queueId')}
                                style={{ width: '100%', padding: '10px 12px', border: '1px solid #784212', borderRadius: '6px', fontSize: '15px', color: '#222', background: '#fff', marginBottom: '24px' }}
                            >
                                <option value="">— Select a Queue —</option>
                                {Object.keys(queues).map(function(k) {
                                    return <option key={k} value={k}>{queues[k].name || k}</option>;
                                })}
                            </select>
                        )}

                        <label style={labelStyle}>Recording</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px', cursor: 'pointer' }} onClick={() => this.setState(function(s) { return { tempData: Object.assign({}, s.tempData, { callRecording: !s.tempData.callRecording }) }; })}>
                            <div style={{ backgroundColor: this.state.tempData.callRecording ? '#002f5f' : '#ddd', color: 'white', borderRadius: '50%', height: '20px', width: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                                {this.state.tempData.callRecording && <svg width="10" height="8" viewBox="0 0 10 8"><path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path></svg>}
                            </div>
                            <span style={{ fontSize: '14px', color: '#333' }}>{this.state.tempData.callRecording ? 'Enabled' : 'Disabled'}</span>
                        </div>

                        {this.state.error && <div className="error" style={{ marginBottom: '14px' }}>{this.state.error}</div>}

                        {this.state.loading
                            ? <div className="loader"></div>
                            : <SaveButton onClick={this.confirmEdit} />
                        }
                    </div>
                </div>
            </div>
        ) : '';

        return (
            <div width="100%">
                {editModal}

                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div style={leftPanelStyle}>
                        {showSidebar && (
                            <div className="filterBox" style={{ width: '210px' }}>
                                <h4>Filter By:</h4>
                                <div style={{ width: '150px' }}>
                                    <label>Number:</label>
                                    <input type="text" onChange={this.filter('number')} value={this.state.filterBy.number || ''} />
                                </div>
                                <div style={{ width: '150px' }}>
                                    <label>Handler:</label>
                                    <input type="text" onChange={this.filter('handlerName')} value={this.state.filterBy.handlerName || ''} />
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ flex: 1 }}>
                        <table style={{ float: 'left', width: '100%' }}>
                            <thead>
                                <tr className="dataRow" style={{ justifyContent: 'flex-start' }}>
                                    <th style={{ width: '220px', flexShrink: 0, cursor: 'pointer', textAlign: 'left' }} onClick={this.sort('number')}>Number{this.filterIcon('number')}</th>
                                    <th style={{ flex: 1.5, cursor: 'pointer', textAlign: 'left' }} onClick={this.sort('description')}>Description{this.filterIcon('description')}</th>
                                    <th style={{ width: '100px', flexShrink: 0, cursor: 'pointer', textAlign: 'left' }} onClick={this.sort('handlerType')}>Type{this.filterIcon('handlerType')}</th>
                                    <th style={{ flex: 1, cursor: 'pointer', textAlign: 'left' }} onClick={this.sort('handlerName')}>Route{this.filterIcon('handlerName')}</th>
                                    <th style={{ width: '120px', flexShrink: 0, textAlign: 'center' }}>Recording</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataList}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '700', letterSpacing: '1px',
    textTransform: 'uppercase', color: '#888', marginBottom: '8px'
};

var badgeBase = { fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', borderRadius: '3px', padding: '2px 6px', verticalAlign: 'middle' };
var badgeStyles = {
    ai:    Object.assign({}, badgeBase, { color: '#1a6e4a', background: '#eafaf1' }),
    ivr:   Object.assign({}, badgeBase, { color: '#1a5276', background: '#eaf3fb' }),
    queue: Object.assign({}, badgeBase, { color: '#784212', background: '#fef5e7' })
};

const icon = "menuPhone";
const roles = ["View", "Edit"];
export { PhoneNumbers, icon, roles };
